import { render, staticRenderFns } from "./videoCenter.vue?vue&type=template&id=a0fcf4da&scoped=true&"
import script from "./videoCenter.vue?vue&type=script&lang=js&"
export * from "./videoCenter.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./videoCenter.vue?vue&type=style&index=0&id=a0fcf4da&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a0fcf4da",
  "30047469"
  
)

export default component.exports